import { render, staticRenderFns } from "./WorkCalendarWeek.vue?vue&type=template&id=2a96c831&scoped=true"
import script from "./WorkCalendarWeek.vue?vue&type=script&lang=js"
export * from "./WorkCalendarWeek.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarWeek.vue?vue&type=style&index=0&id=2a96c831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96c831",
  null
  
)

export default component.exports